/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listTools} from '../api'

export const useMutationListTools = createReactQueryMutationHook('listTools', listTools)
